import gsap from "gsap";

class Defiling {
  constructor(container) {
    this.container = container;
    this.items = container.querySelectorAll("[data-defiling-item]");
    this.init();
  }

  init() {
    gsap.to(this.items, {
      xPercent: -100,
      ease: "linear",
      duration: 10,
      repeat: -1,
    });
  }
}

export default Defiling;
